import React from "react";
import HeaderNav from "../../header/header";
import {Button, Checkbox, Col, DatePicker, Form, Input, Layout, message, Row, Select, Space, Spin, Table} from "antd";
import moment from "moment";
import "../css/SingleCreateFinancialClaim.css"
import {Option} from "antd/es/mentions";
import {dispute_types,dispute_approval_search} from "../../../requist";
import DisputeApprovalTable from "./disputeApprovalTable";
const { Content } = Layout;

class DisputeApproval extends React.Component{
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state={
            selectedRowKeys:[],
            isModalVisible:false,
            optionList:[],
            region:'WE',
            businessUnit:'P',
            data:[],
            loading:false,
            // data:[{disputeNo:'DP20210810'},{disputeNo:'DP20210810'}]
        }
    }
    onRegionChange=(value)=>{
        let we_dispute_types=[]
        const { businessUnit } = this.state;
        dispute_types().then((res)=>{
            res.data.map((item)=>{
                if(item.region==value && item.businessUnit==businessUnit){
                    we_dispute_types.push(item)
                }
            })
            we_dispute_types.push({"disputeType":'ALL',"disputeTypeText":'ALL'})
            this.setState({region:value,optionList:we_dispute_types})
        })
    }
    onBusinessUnitChange=(value)=>{
        let we_dispute_types=[]
        const { region } = this.state;
        dispute_types().then((res)=>{
            res.data.map((item)=>{
                if(item.region==region && item.businessUnit==value){
                    we_dispute_types.push(item)
                }
            })
            we_dispute_types.push({"disputeType":'ALL',"disputeTypeText":'ALL'})
            this.setState({businessUnit:value,optionList:we_dispute_types})
        })
    }

    componentWillMount(){
        let uesrId = window.localStorage.getItem('userId')
        if(!uesrId){
            message.warn('Please log in first!')
            this.props.history.push({
                pathname: '/disputeHome'
            })
        }
    }
    componentDidMount() {
        let we_dispute_types=[]
        dispute_types().then((res)=>{
            // res.data.map((item)=>{
            //     if(item.region=='WE' && item.businessUnit=='P'){
            //         we_dispute_types.push(item)
            //     }
            // })
            we_dispute_types.push({"disputeType":'ALL',"disputeTypeText":'ALL'})
            this.setState({optionList:we_dispute_types})
        })
    }

    onFinish=(values)=>{
        this.setState({loading:true})
        if (!Array.isArray(values.disputeNo)) {
            values.disputeNo = values.disputeNo ? values.disputeNo.split(',') : undefined;
        }
        if (!Array.isArray(values.invoiceNo)) {
            values.invoiceNo = values.invoiceNo ? values.invoiceNo.split(',') : undefined;
        }
        if (!Array.isArray(values.soldTo)) {
            values.soldToList = values.soldTo ? values.soldTo.split(',') : undefined;
        } else {
            values.soldToList = values.soldTo;
        }
        values.soldTo = null;
        if(values.disputeType){
            if(values.disputeType==='ALL'){
                values.disputeType=undefined
            }else{
                values.disputeType.map(item=>{
                    if(item=="ALL"){
                        values.disputeType=undefined
                    }
                })
            }
        }
        let params={
            ...values,
            region: values.region=="ALL"?undefined:values.region,
            businessUnit: values.businessUnit=="ALL"?undefined:values.businessUnit,
            createdOnFrom: values.createdOnFrom ? moment(values.createdOnFrom).format('YYYY-MM-DD') + ' 00:00:00' : undefined,
            createdOnTo:values.createdOnTo ? moment(values.createdOnTo).format('YYYY-MM-DD') + ' 23:59:59' : undefined,
        }
        this.setState({params})
        dispute_approval_search(params).then((res)=>{
            if(res.retCode==='200'){
                this.setState({data:res.data})
                this.setState({loading:false})
            }else{
                message.warn(`${res.retMsg}`)
                this.setState({loading:false})
            }
        })
    }
    dpSplit=(e,name)=>{
        let value = e.target.value
        if (value.indexOf(" ") == -1) {

        } else {
            if(value){
                const obj ={}
                obj[name] = value.trim().split(/\s+/)
                this.formRef.current.setFieldsValue(obj)
            }
        }
    }
    render() {
        const { selectedRowKeys,data,optionList,loading } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        return <div>
            <HeaderNav parmas={'/disputeApproval'}/>
            <Layout className="site-layout-background singleFinancialClaimEdit" style={{ padding: '24px 0',margin: '0 auto'  }}>
                <div className="example" style={{display:loading?'block':'none'}}>
                    <Spin spinning={loading} />
                </div>
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    <h1>Dispute approval</h1>
                    <Form
                        name="internal"
                        labelCol={{ span:12 }}
                        wrapperCol={{ span: 12}}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        ref={this.formRef}
                    >
                        <Row>
                            <Col span={8}>
                                <Form.Item
                                    label="Region"
                                    name="region"
                                    rules={[{ required: false }]}
                                    initialValue={'ALL'}
                                >
                                    <Select onChange={this.onRegionChange}>
                                        <Option value={'WE'}>WE</Option>
                                        <Option value={'EM'}>EM</Option>
                                        <Option value={'ALL'}>ALL</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="PCG/DCG"
                                    name="businessUnit"
                                    rules={[{ required: false }]}
                                    initialValue={'ALL'}
                                >
                                    <Select onChange={this.onBusinessUnitChange}>
                                        <Option value={'P'}>PCG</Option>
                                        <Option value={'D'}>DCG</Option>
                                        <Option value={'ALL'}>ALL</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Dispute Type"
                                    name="disputeType"
                                    rules={[{ required: false }]}
                                    initialValue={'ALL'}
                                >
                                    <Select
                                        mode="tags"
                                        placeholder="Please select"
                                        style={{ width: '100%' }}
                                        dropdownMatchSelectWidth={240}
                                    >
                                        {
                                            this.state.optionList.map((item)=>{
                                                return <Option value={item.disputeType} >{item.disputeTypeText}</Option>
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Dispute No"
                                    name="disputeNo"
                                    tooltip={'Dispute No can input multi-value and it should be separated by comma'}
                                    rules={[{ required: false }]}
                                >
                                    <Input onChange={(e)=>this.dpSplit(e, 'disputeNo')}/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Create From"
                                    name="createdOnFrom"
                                    rules={[{ required: true }]}
                                    initialValue={moment(new Date()).subtract(1,"month")}
                                >
                                    <DatePicker />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Create To"
                                    name="createdOnTo"
                                    rules={[{ required: true }]}
                                    initialValue={moment(new Date())}
                                >
                                    <DatePicker />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Invoice Number"
                                    name="invoiceNo"
                                    tooltip={'Invoice No can input multi-value and it should be separated by comma'}
                                    rules={[{ required: false }]}
                                >
                                    <Input onChange={(e)=>this.dpSplit(e, 'invoiceNo')}/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sold to"
                                    name="soldTo"
                                    tooltip={'Sold to can input multi-value and it should be separated by comma'}
                                    rules={[{ required: false }]}
                                >
                                    <Input onChange={(e)=>this.dpSplit(e, 'soldTo')}/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Dispute Status"
                                    name="status"
                                    rules={[{ required: false }]}
                                >
                                    <Select
                                        mode="tags"
                                        placeholder="Please select"
                                        style={{ width: '100%' }}
                                    >
                                        <Option value={'DWAAP'}>Waiting for dispute initial approval</Option>
                                        <Option value={'DWFOA'}>Waiting for dispute offline approval</Option>
                                        <Option value={'DAPPR'}>Dispute approved</Option>
                                        <Option value={'DREJE'}>Dispute rejected</Option>
                                        <Option value={'DCLOS'}>Dispute Billed</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Button style={{marginBottom:10,float:'right',position:'relative',bottom:'-42px'}} type="primary" htmlType="submit">
                            Search
                        </Button>
                    </Form>
                    <DisputeApprovalTable dataSource={data} />
                    {/*<Space style={{marginBottom:20}}>*/}
                    {/*    <Button type="primary" onClick={this.onApprove}>*/}
                    {/*        Approve*/}
                    {/*    </Button>*/}
                    {/*    <Button type="primary" onClick={this.onReject}>*/}
                    {/*        Reject*/}
                    {/*    </Button>*/}
                    {/*    <Button type="primary" onClick={this.onOfflineApprove}>*/}
                    {/*        Offline Approve*/}
                    {/*    </Button>*/}
                    {/*</Space>*/}
                    {/*<Table*/}
                    {/*    bordered*/}
                    {/*    rowKey={'disputeNo'}*/}
                    {/*    scroll={{x:1700}}*/}
                    {/*    rowSelection={rowSelection}*/}
                    {/*    columns={columns}*/}
                    {/*    dataSource={this.state.data}*/}
                    {/*/>*/}
                </Content>
            </Layout>
        </div>
    }
}

export default DisputeApproval;